import { PortfolioProfitsAndLosses } from "types/ProfitsAndLosses";
import { createCustomAction } from "typesafe-actions";

const PROFITS_AND_LOSSES_DATA_LOAD =
  "PROFITS_AND_LOSSES/PROFITS_AND_LOSSES_DATA_LOAD";
const PROFITS_AND_LOSSES_DATA_LOAD_SUCCESS =
  "PROFITS_AND_LOSSES/PROFITS_AND_LOSSES_DATA_LOAD_SUCCESS";
const PROFITS_AND_LOSSES_DATA_LOAD_FAIL =
  "PROFITS_AND_LOSSES/PROFITS_AND_LOSSES_DATA_LOAD_FAIL";

export const load = createCustomAction(
  PROFITS_AND_LOSSES_DATA_LOAD,
  (type) => () => ({
    type,
  })
);

export const loadSuccess = createCustomAction(
  PROFITS_AND_LOSSES_DATA_LOAD_SUCCESS,
  (type) => (data?: PortfolioProfitsAndLosses[]) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(
  PROFITS_AND_LOSSES_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);
